import { renderLayerDom } from '@/utils/render-kit';
import type { ILayerProps, ITextLayerProps } from '@/version-types';
import TextLayer from './text-layer';

export const renderDom = (identity: string, layer: ILayerProps): Promise<() => void> => {
    return new Promise((resolve) => {
        if ((layer.data as ITextLayerProps).screenshotUrl) {
            return;
        }

        const dispose = renderLayerDom(
            <TextLayer
                identity={identity}
                layer={layer}
                isNavigator={false}
                onRenderEnd={() => {
                    resolve(dispose);
                }}
            />,
        );
    });
};
